import { Column } from "react-table";

export default [
    {
        Header: 'Group',
        accessor: 'name',
        width: '33%'
    },
    {
        Header: 'Email',
        accessor: 'email',
        width: '33%'
    },
    {
        Header: 'Owner',
        accessor: 'owner.email',
        width: '33%'
    },
    {
        Header: 'Address',
        accessor: 'address'
    },
    {
        Header: 'Zip',
        accessor: 'zip'
    },
    {
        Header: 'Members',
        accessor: 'members_count'
    }
] as Column<Club.Admin.Resources.Club>[]